/* 🤖 this file was generated by svg-to-ts */
export const mgcIconTriangleRegular: {
  name: 'triangle-regular';
  data: string;
} = {
  name: 'triangle-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.61 2.444c-.21.05-.628.329-.774.516-.2.256-8.812 15.216-8.889 15.44-.11.32-.08.79.068 1.094a1.6 1.6 0 0 0 .735.714l.268.132h17.964l.268-.132c.531-.261.83-.694.862-1.246a1.484 1.484 0 0 0-.047-.525c-.04-.136-1.707-3.064-4.437-7.797-3.467-6.009-4.415-7.622-4.571-7.782a1.378 1.378 0 0 0-.973-.44 2.19 2.19 0 0 0-.474.026m4.281 9.187 3.871 6.709-3.881.01c-2.134.006-5.628.006-7.762 0l-3.881-.01 3.871-6.709c2.129-3.69 3.88-6.709 3.891-6.709s1.762 3.019 3.891 6.709"/></svg>`
};
